import { Loading } from '@busie/ui-kit'
import { env } from '@busie/utils'
import { enableLogging } from 'mobx-logger'
import React, { lazy, Suspense, useEffect } from 'react'
import './styles/index.css'

const LazyFeatureFlagsProvider = lazy(() =>
  import('./providers/LazyFeatureFlagsProvider').then((module) => ({
    default: module.LazyFeatureFlagsProvider,
  }))
)

const LazyAuthProviders = lazy(() =>
  import('./providers/LazyAuthProviders').then((module) => ({
    default: module.LazyAuthProviders,
  }))
)

const LazyI18nProvider = lazy(() =>
  import('./providers/LazyI18nProvider').then((module) => ({
    default: module.LazyI18nProvider,
  }))
)

export const App: React.FC<React.PropsWithChildren<unknown>> = () => {
  const qs = window.location.search
  const urlParams = new URLSearchParams(qs)
  const invitation = urlParams.get('invitation') || undefined
  const organization = urlParams.get('organization') || undefined

  useEffect(() => {
    enableMobxLogging()
  }, [])

  // Check if we should skip the redirect callback
  const skipRedirectCallback =
    !window.location.search.includes('code=') &&
    !window.location.search.includes('state=') &&
    !window.location.search.includes('error=')

  console.log('[App] Initial load:', {
    skipRedirectCallback,
    hasInvitation: !!invitation,
    hasOrganization: !!organization,
    search: window.location.search,
  })

  return (
    <Suspense fallback={<Loading fillContainer />}>
      <LazyI18nProvider>
        <LazyAuthProviders
          invitation={invitation}
          organization={organization}
          skipRedirectCallback={skipRedirectCallback}
        >
          <LazyFeatureFlagsProvider />
        </LazyAuthProviders>
      </LazyI18nProvider>
    </Suspense>
  )
}

const enableMobxLogging = () => {
  const isDevelopment = process.env.NODE_ENV === 'development'

  const isLoggingDisabled = env.VITE_DISABLE_MOBX_LOGGING?.toLowerCase() === 'true'

  const isLoggingEnabled = isDevelopment && !isLoggingDisabled
  if (isLoggingEnabled) {
    enableLogging({
      action: true,
      reaction: true,
      transaction: true,
      compute: true,
    })
  }
}
